<template>
  <div class="relative">
    <input
      :id="inputId"
      type="text"
      :value="modelValue" 
      @input="$emit('update:modelValue', $event.target.value)" 
      :class="[
        'input-responsive uppercase',
        { 'border-red-300 bg-red-50 focus:ring-red-500 focus:border-red-500': hasError },
        !hasError ? (
          userRole === 'customer' ? 'focus:ring-green-500 focus:border-green-500' : 'focus:ring-primary-500 focus:border-primary-500'
        ) : ''
      ]"
      placeholder="Enter policy number"
    />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { Icon } from '@iconify/vue';
// No need to import RouterLink explicitly in script setup when used in template

// Props for v-model support
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  // Optional: Allow passing a unique ID if needed, otherwise generate one
  id: {
    type: String,
    default: null
  },
  hasError: {
    type: Boolean,
    default: false
  },
  userRole: {
    type: String,
    default: 'lender', // 'lender' uses primary-xxx classes, 'customer' uses green-xxx
    validator: (value) => ['customer', 'lender'].includes(value)
  }
});

// Emits for v-model support
defineEmits(['update:modelValue']);

// Internal state for popup
const showPopup = ref(false);
const popupHideDelay = 800; // milliseconds
let hideTimeoutId = null;

const hidePopupWithDelay = () => {
  clearTimeout(hideTimeoutId);
  hideTimeoutId = setTimeout(() => {
    showPopup.value = false;
  }, popupHideDelay);
};

// Generate a unique ID for label/input association if not provided
const inputId = computed(() => props.id || `policy-number-input-${Math.random().toString(36).substring(7)}`);

// Clear timeout on unmount
import { onUnmounted } from 'vue';
onUnmounted(() => {
  clearTimeout(hideTimeoutId);
});
</script>

<style scoped>
/* Remove the form-input class definition since we're now using input-responsive */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style> 